// extracted by mini-css-extract-plugin
export var divider = "_ex-7";
export var itemsToggle = "_ex-8";
export var mergeModal = "_ex-1";
export var optionCard = "_ex-4";
export var radioGroup = "_ex-6";
export var radioOption = "_ex-0";
export var selected = "_ex-5";
export var shipmentOptions = "_ex-2";
export var tableOptions = "_ex-3";